import Default from './default';
export {
  Default
}



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/templates/pages/index.js